import styled from "styled-components";

export const ListContainer = styled.div`
  .videoList {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .emptyState {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 4px;
    box-shadow: rgba(3, 3, 3, 0.1) 2px 0px 10px;

    p {
      color: ${({ theme }) => theme.colors.gray};
      font-size: 16px;
    }
  }
`;
